/* Keeps the free-delivery progress honest after AJAX cart changes.
 *
 * The strip renders server-side, so it is correct on load. The problem is the cart
 * drawer: adding an item never reloads the page, and a bar still saying "spend £30
 * more" after the customer just added £30 is worse than no bar at all.
 *
 * This theme dispatches no cart events of its own, so rather than guess at one, the
 * trigger is the header cart bubble: whatever updates the basket has to update that
 * too. Watching it with a MutationObserver works regardless of how the cart is
 * wired, and keeps working if the cart implementation changes.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-ms-ship]');
  if (!root) return;

  var textEl = root.querySelector('[data-ms-ship-text]');
  var trackEl = root.querySelector('[data-ms-ship-track]');
  var fillEl = root.querySelector('[data-ms-ship-fill]');
  var threshold = Number(root.dataset.msShipThreshold || 0);
  if (!threshold) return;

  /* Read the strings off the rendered markup rather than duplicating them here, so
     the copy stays editable in the theme editor and is never translated twice. */
  var copy = {
    empty: root.dataset.msShipEmpty || '',
    remaining: root.dataset.msShipRemaining || '',
    met: root.dataset.msShipMet || '',
  };

  function money(pence) {
    return (pence / 100).toLocaleString('en-GB', {
      style: 'currency', currency: 'GBP',
      minimumFractionDigits: pence % 100 === 0 ? 0 : 2,
    });
  }

  function render(total) {
    var remaining = threshold - total;
    var pct = Math.min(100, Math.round((total / threshold) * 100));

    if (total === 0) {
      if (copy.empty) textEl.textContent = copy.empty.replace('[amount]', money(threshold));
      trackEl.hidden = true;
    } else if (remaining > 0) {
      if (copy.remaining) textEl.textContent = copy.remaining.replace('[amount]', money(remaining));
      trackEl.hidden = false;
    } else {
      if (copy.met) textEl.innerHTML = '<span class="ms-ship__met"></span>';
      textEl.firstChild.textContent = copy.met;
      trackEl.hidden = false;
    }
    fillEl.style.width = pct + '%';
  }

  var pending = null;
  function refresh() {
    window.clearTimeout(pending);
    /* Debounced: the bubble can mutate several times for one add. */
    pending = window.setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) render(cart.total_price); })
        .catch(function () { /* leave the server-rendered value alone */ });
    }, 250);
  }

  var bubble = document.querySelector('.cart-bubble, [class*="cart-bubble"]');
  if (bubble) {
    new MutationObserver(refresh).observe(bubble, {
      childList: true, subtree: true, characterData: true, attributes: true,
    });
  }

  /* Belt and braces for themes or apps that do announce a change. */
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
